export default __webpack_public_path__ + "img/272b1fc1ea6effbe2523f5d2afb213a8.png";